<template>
  <search-group
  @search="findData"
  @clear="clearValue"
  :span="24"
  :btnOffset="12"
  :btnSpan="6"
  :inline="true"
  >
    <Row class="mb16" :gutter="16">
      <Col span="5">
        <Select v-model="searchData.orgFid" placeholder="二级机构名称" >
          <Option value=''>请选择</Option>
          <Option v-for="item in companyList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      
      <Col span="5">
        <DatePicker type="datetimerange" placeholder="创建时间筛选" format="yyyy-MM-dd" style="width: 200px" v-model="searchData.createTime"></DatePicker>
      </Col>
    </Row>
    
  </search-group>
</template>

<script>
import SearchGroup from 'components/SearchGroup/index';
// import { allCompany , metaPermissionListByPage } from 'api/metadistribution'
import {formatDateTime} from "../../../../../utils/format";

export default {
  components:{
    SearchGroup
  },
  props:{
    companyList:{
      type:Array,
      default(){
        return []
      }
    }
  },
  data(){
    return{
      searchData:{
        orgFid: null,
        createTime: ['', '']
      },
      createtTimeRange:[],
      company:{},
      startDateTime:[],
      endDateTime:[]
    }
  },
  watch:{
    companyList(newVal,oldVal){
      this.companyList = newVal
    }
  },
  mounted(){
    this.$emit('searchParams', this.searchDataParams);
  },
  computed:{
    searchDataParams(){
      function f(data) {
        return data?formatDateTime(data, false):''
      }
      return {
        orgFid:this.searchData.orgFid,
        beginDate: f(this.searchData.createTime[0]),
        endDate:f(this.searchData.createTime[1])
      }
    }
  },
  methods:{
    formatDate(str){
      if(!str){
        return ''
      }
      return formatDateTime(str)
    },
    findData(){
      this.$emit('searchParams',this.searchDataParams)
    },
    clearValue(){
      this.searchData = {
        orgFid:'',
        createTime: ['', '']
      }
    }
  }
}
</script>

<style>

</style>